module.exports = __webpack_public_path__ + "img/CZ.30fa8d52.svg";